<p-fieldset [toggleable]="true">
  <p-header>
    <b><ng-content select="[content-header]"></ng-content></b>
  </p-header>
  <br>
  <div class="padding">
    <ng-content select="[content-body]"></ng-content>
  </div>
</p-fieldset>
<br><br>